import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import FooterNav from './FooterNav';

const Footer: React.FC = () => (
  <footer className="bg-nav text-gray-300 mt-auto">
    <div className="bg-yellow-500/10 border-t border-yellow-500/30">
      <div className="container mx-auto px-4 py-3 text-center text-sm text-yellow-200">
        <span className="font-semibold">Affiliate Disclosure: </span>
        As an Amazon Associate I earn from qualifying purchases. Product links on this site are{' '}
        <Link to="/disclosure" className="underline hover:text-yellow-100">paid links (#CommissionsEarned)</Link>.
      </div>
    </div>
    <div className="container mx-auto px-4 py-10">
      <FooterNav />
      <hr className="border-gray-700 my-8" />
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <p>© {new Date().getFullYear()} Amazon Onlines. All rights reserved.</p>
          <div style={{ margin: 0, fontSize: '12px', color: '#999', flexShrink: 0 }}>
            Powered by{' '}
            <a
              href="https://www.hasmandesign.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#666', textDecoration: 'none' }}
            >
              Hasman Design LLC
            </a>
          </div>
        </div>
        <p className="flex items-center gap-1 flex-wrap justify-center">
          <strong className="text-gray-400">As an Amazon Associate I earn from qualifying purchases.</strong>
          <a href="https://amazon.com" target="_blank" rel="noopener noreferrer" className="text-accent inline-flex items-center gap-0.5 hover:underline ml-1">
            Amazon <ExternalLink className="w-3 h-3" />
          </a>
          <span className="text-gray-600 mx-1">•</span>
          <a
            href="https://www.facebook.com/profile.php?id=61591490982052"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent inline-flex items-center gap-0.5 hover:underline"
            aria-label="Follow Amazon Onlines on Facebook"
          >
            Follow Amazon Onlines on Facebook <ExternalLink className="w-3 h-3" />
          </a>
        </p>
      </div>
      <p className="text-center text-[10px] text-gray-600 dark:text-gray-700 mt-4 leading-relaxed">
        CERTAIN CONTENT THAT APPEARS ON THIS SITE COMES FROM AMAZON. THIS CONTENT IS PROVIDED &ldquo;AS IS&rdquo; AND IS SUBJECT TO CHANGE OR REMOVAL AT ANY TIME.
      </p>
    </div>
  </footer>
);

export default Footer;

